module.exports = __webpack_public_path__ + "img/motorcycle.4ee909fb.png";